import { EditLicensingOptionsMenuBaseDataProvider } from './EditLicensingOptionsMenuBaseDataProvider';
import { CompanyData } from '../../../types/company-data';

export class EditLicensingOptionsMenuGzDataProvider extends EditLicensingOptionsMenuBaseDataProvider {
  public async getManagedCompanyById(companyId: string): Promise<CompanyData> {
    const record = await this.dependencies.api.clients.Company.GetManagedCompanyById(companyId).toPromise();

    if (!record) {
      throw new Error('No edited company data');
    }

    return record;
  }
}
